import Image from 'next/image'
import Link from 'next/link'
import { FC } from 'react'

import { CatalogItem } from '@/entities/catalog/types'

import { BASE_URL } from '@/shared/lib/const/env'

import cl from './CategoriesList.module.scss'

export type CategoriesListProps = {
	catalogItems: CatalogItem[]
}

export const CategoriesList: FC<CategoriesListProps> = ({ catalogItems }) => {
	if (!catalogItems.length) return null

	return (
		<section className={cl.root}>
			<ul className={cl.list}>
				{catalogItems.map(({ NAME, ID, LINK, PREVIEW_PICTURE, withBaseUrl = true }) => (
					<li className={cl.item} key={ID}>
						<Link prefetch={false} href={LINK} className={cl.link}>
							<article className={cl.imageWrap}>
								<Image
									src={withBaseUrl ? BASE_URL + PREVIEW_PICTURE : PREVIEW_PICTURE}
									width={140}
									height={140}
									alt={NAME}
								/>
							</article>
							<p className={cl.title}>{NAME}</p>
						</Link>
					</li>
				))}
			</ul>
		</section>
	)
}
